import { CONFIG } from './config';

// URL 파라미터 추출 함수
export const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};
  
  // 모든 파라미터를 객체로 변환
  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }
  
  return params;
};

// 리다이렉트 함수
export const redirectToTarget = (redirectUrl, step, params = {}) => {
  let targetUrl;

  // 1순위: URL 쿼리에 ?redirect= 가 있으면 그대로 사용
  if (redirectUrl) {
    targetUrl = redirectUrl;
  }
  // 2순위: step1이고 deviceId가 매핑에 존재하면 baseURL + path + query 조립
  else if (
    step === 'step1' &&
    params.deviceId &&
    CONFIG.DEVICE_REDIRECT_MAP[params.deviceId] &&
    CONFIG.REDIRECT_BASE_URL
  ) {
    const mapping = CONFIG.DEVICE_REDIRECT_MAP[params.deviceId];
    targetUrl = `${CONFIG.REDIRECT_BASE_URL}${mapping.path}?${mapping.query}`;
  }
  // 3순위: env 폴백 (deviceId 없음 또는 매핑에 없음)
  else {
    targetUrl = CONFIG.REDIRECT_URLS[step] || CONFIG.DEFAULT_REDIRECT_URL;
  }

  // step별로 필요한 파라미터 추가
  if (step === 'step1') {
    // Step1에서 리다이렉트할 때 sessionId를 k 파라미터로 추가
    if (params.sessionId) {
      const url = new URL(targetUrl);
      url.searchParams.set('k', params.sessionId);
      targetUrl = url.toString();
    }
  } else if (step === 'step2') {
    // Step2에서 리다이렉트할 때 serialNumber를 파라미터로 추가
    if (params.serialNumber) {
      const url = new URL(targetUrl);
      url.searchParams.set('serialNumber', params.serialNumber);
      targetUrl = url.toString();
    }
  }

  window.location.href = targetUrl;
};

// 메인 로그 처리 및 리다이렉트 함수
export const processLogAndRedirect = async (onLoadingStart, step) => {
  const startTime = Date.now();
  let showLoading = false;
  
  // 로딩 화면 표시 타이머 설정
  const loadingTimer = setTimeout(() => {
    showLoading = true;
    if (onLoadingStart) {
      onLoadingStart();
    }
  }, CONFIG.LOADING_THRESHOLD);

  try {
    // URL 파라미터 추출
    const params = getUrlParams();
    if (CONFIG.DEBUG_MODE) {
      console.log('추출된 파라미터:', params);
    }
    
    // 리다이렉트 URL 확인 (redirect 파라미터가 있으면 해당 URL로, 없으면 기본 URL로)
    const redirectUrl = params.redirect;
    
    // 로딩 타이머 정리
    clearTimeout(loadingTimer);
    
    // API 응답이 빠르면 즉시 리다이렉트, 느리면 잠시 대기 후 리다이렉트
    const elapsedTime = Date.now() - startTime;
    if (showLoading) {
      // 로딩 화면이 표시된 경우 잠시 대기 후 리다이렉트
      setTimeout(() => {
        redirectToTarget(redirectUrl, step, params);
      }, 300);
    } else {
      // 로딩 화면이 표시되지 않은 경우 즉시 리다이렉트
      redirectToTarget(redirectUrl, step, params);
    }
    
  } catch (error) {
    if (CONFIG.DEBUG_MODE) {
      console.error('처리 중 오류 발생:', error);
    }
    
    // 로딩 타이머 정리
    clearTimeout(loadingTimer);
    
    // 에러가 발생해도 리다이렉트는 실행
    const params = getUrlParams();
    const redirectUrl = params.redirect;
    
    if (showLoading) {
      // 로딩 화면이 표시된 경우 잠시 대기 후 리다이렉트
      setTimeout(() => {
        redirectToTarget(redirectUrl, step, params);
      }, 500);
    } else {
      // 로딩 화면이 표시되지 않은 경우 즉시 리다이렉트
      redirectToTarget(redirectUrl, step, params);
    }
  }
};

// API 호출 없이 리다이렉트만 하는 함수
export const processLogAndRedirectWithoutAPI = async (onLoadingStart, step, params = {}) => {
  const startTime = Date.now();
  let showLoading = false;
  
  // 로딩 화면 표시 타이머 설정
  const loadingTimer = setTimeout(() => {
    showLoading = true;
    if (onLoadingStart) {
      onLoadingStart();
    }
  }, CONFIG.LOADING_THRESHOLD);

  try {
    if (CONFIG.DEBUG_MODE) {
      console.log('API 호출 없이 리다이렉트 처리:', { step, params });
    }
    
    // 로딩 타이머 정리
    clearTimeout(loadingTimer);
    
    // 리다이렉트 URL 확인
    const redirectUrl = params.redirect;
    
    // API 응답이 빠르면 즉시 리다이렉트, 느리면 잠시 대기 후 리다이렉트
    const elapsedTime = Date.now() - startTime;
    if (showLoading) {
      // 로딩 화면이 표시된 경우 잠시 대기 후 리다이렉트
      setTimeout(() => {
        redirectToTarget(redirectUrl, step, params);
      }, 300);
    } else {
      // 로딩 화면이 표시되지 않은 경우 즉시 리다이렉트
      redirectToTarget(redirectUrl, step, params);
    }
    
  } catch (error) {
    if (CONFIG.DEBUG_MODE) {
      console.error('리다이렉트 처리 중 오류 발생:', error);
    }
    
    // 로딩 타이머 정리
    clearTimeout(loadingTimer);
    
    // 에러가 발생해도 리다이렉트는 실행
    const redirectUrl = params.redirect;
    
    if (showLoading) {
      // 로딩 화면이 표시된 경우 잠시 대기 후 리다이렉트
      setTimeout(() => {
        redirectToTarget(redirectUrl, step, params);
      }, 500);
    } else {
      // 로딩 화면이 표시되지 않은 경우 즉시 리다이렉트
      redirectToTarget(redirectUrl, step, params);
    }
  }
};
